import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { ratioKeys } from "./query-keys";

interface ListRatioParams {
  offset?: number;
  limit?: number;
}

export function useListRatio({ offset = 0, limit = 50 }: ListRatioParams = {}) {
  return useQuery({
    queryKey: ratioKeys.list(offset, limit),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/inventory-ratio", {
        params: { query: { offset, limit } },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
